<template>
  <div>
    <a-modal v-model:visible="visible" title="脉诊记录" @ok="handleOk" okText="确认" cancelText="取消" :afterClose="closeModal" :cancelButtonProps="{ style: { display: 'none' }}" width="55vw">

      <a-table class="ant-table-striped" :columns="columns" :data-source="data" rowKey="id" :pagination="{pageSize:6 }" bordered>

        <template #operation="{ record }">
          <div class="flex_sa">

            <div class="editable-row-operations">
              <span>
                <a-popconfirm v-if="data.length" title="是否确认删除" @confirm="emitCallback(record)" okText="确认" cancelText="取消">
                  <a>导入</a>
                </a-popconfirm>
              </span>
            </div>
          </div>
        </template>
      </a-table>

      <!-- <div style="text-align: center;margin-top: 20px;">
        <a-button type="primary" @click="visible2=true">新增权限</a-button>
      </div> -->
    </a-modal>
  </div>
  <!-- <addPrescription v-model="visible2" @getData="callbackData" /> -->
</template>

<script>
import { reactive } from "vue";
import { GetMaizhenyiList } from "/src/api/medicalRecord.js";
export default {
  components: {
  },
  data() {
    return {
      visible: this.modelValue,
      employeeId: "",
      clubId: "",
      selectedRows: {},
      columns: [
        {
          title: "检测时间",
          key: "createdDate",
          dataIndex: "createdDate",
          width: "25%",
          slots: {
            customRender: "createdDate"
          }
        },
        {
          title: "脉诊结果",
          key: "pulseResult",
          dataIndex: "pulseResult",
          width: "25%",
          slots: {
            customRender: "pulseResult"
          }
        },
        {
          title: "运脉",
          key: "yunmai",
          dataIndex: "yunmai",
          width: "25%",
          slots: {
            customRender: "yunmai"
          }
        },
        {
          title: "操作",
          dataIndex: "operation",
          width: "25%",
          slots: {
            customRender: "operation"
          }
        }
      ],
      data: [],
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
    };
  },
  emits: ['update:modelValue'],
  created() {

  },
  mounted() {
  },
  activated() {
  },
  //获取父元素传值
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: Number,
      default: -1
    },
  },
  computed: {
  },
  methods: {
    async detail() {
      
      let res = await GetMaizhenyiList({ customerId: this.customerId })

      console.log(res);
      // console.log(res)
      if (res.errCode == 0) {
        this.data = res.data
      } else {
        this.$message.error("详情查询失败", function () { });
      }
    },
    async handleOk() {
      let _this = this;
      let res = await Add({ groupId: this.record.id, permissionId: this.permissionId })
      if (res.errCode == 0) {
        _this.$message.success("关联成功", function () { });
        _this.visible = false
        // _this.reload = true
        this.permissionIdList = []
      }
    },
    emitCallback(record) {
      console.log(record);

      this.$emit("maizhenyiCallback", {
        leftCun: record.leftCun,
        rightCun: record.rightCun,
        leftGuan: record.leftGuan,
        rightGuan: record.rightGuan,
        leftChi: record.leftChi,
        rightChi: record.rightChi,
        fubingDiagnose: record.pulseResult,
        tcmDiagnose: record.yunmai
      });
      this.closeModal()
    },
    async onDelete(id) {

      let res = await Delete({ id })
      if (res.errCode == 0) {
        this.data = this.data.filter(function (item) {
          return item.id !== id;
        });
      }

    },
    closeModal() {
      this.$emit('update:modelValue', false);
      //   if (this.reload) {
      //     this.$emit("reload")
      //   }
    },

  },
  watch: {
    customerId(val) {
      this.detail()
    },
    modelValue(val) {
      this.visible = val
    },
  }
};
</script>

<style scoped>
.head {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head span {
  font-weight: bold;
  margin-right: 10px;
}
.head2 {
  display: flex;
  margin-bottom: 20px;
  justify-content: center;
  align-items: center;
}
.head2 span {
  font-weight: bold;
  margin-right: 10px;
}
</style>
